import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';

const AssessmentHeader = ({
  classes,
  selectedClass,
  setSelectedClass,
  courses,
  selectedCourse,
  setSelectedCourse,
  books,
  selectedBook,
  setSelectedBook,
  learningAreas,
  selectedLearningArea,
  setSelectedLearningArea,
  activities,
  selectedActivity,
  setSelectedActivity,
  assessments,
  selectedAssessment,
  setSelectedAssessment,
  assessedOn,
  setAssessedOn,
  headerChips,
  loadingInit,
  loadingBooks,
  loadingAreas,
  loadingActivities,
  loadingSession,
  saving,
}) => {
  return (
    <Paper sx={{ p: { xs: 1.5, sm: 2 }, mb: 2, borderRadius: 2 }}>
      <Grid container spacing={1.5} alignItems="center">
        <Grid item xs={12} md={6}>
          <Autocomplete
            size="small"
            options={classes}
            value={selectedClass}
            getOptionLabel={(opt) => String(opt?.name || '')}
            onChange={(_, v) => setSelectedClass(v || null)}
            loading={loadingInit}
            renderInput={(params) => <TextField {...params} label="Şube" placeholder="Seçin" fullWidth />}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Autocomplete
            size="small"
            options={courses}
            value={selectedCourse}
            getOptionLabel={(opt) => String(opt?.name || '')}
            onChange={(_, v) => setSelectedCourse(v || null)}
            loading={loadingInit}
            renderInput={(params) => <TextField {...params} label="Ders" placeholder="Seçin" fullWidth />}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Autocomplete
            size="small"
            options={books}
            value={selectedBook}
            getOptionLabel={(opt) => String(opt?.book_name || '')}
            onChange={(_, v) => setSelectedBook(v || null)}
            loading={loadingBooks}
            renderInput={(params) => <TextField {...params} label="Kitap" placeholder="Seçin" fullWidth />}
          />
          {selectedBook?.book_url ? (
            <Box sx={{ mt: 0.75 }}>
              <Button size="small" variant="text" href={String(selectedBook.book_url)} target="_blank" rel="noreferrer">
                Kitap linkini aç
              </Button>
            </Box>
          ) : null}
        </Grid>

        <Grid item xs={12} md={6}>
          <Autocomplete
            size="small"
            options={learningAreas}
            value={selectedLearningArea}
            getOptionLabel={(opt) => String(opt?.name || '')}
            onChange={(_, v) => setSelectedLearningArea(v || null)}
            loading={loadingAreas}
            renderInput={(params) => <TextField {...params} label="Öğrenme Alanı" placeholder="Seçin" fullWidth />}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Autocomplete
            size="small"
            options={activities}
            value={selectedActivity}
            getOptionLabel={(opt) => String(opt?.name || '')}
            onChange={(_, v) => setSelectedActivity(v || null)}
            loading={loadingActivities}
            renderInput={(params) => <TextField {...params} label="Öğrenme Etkinliği" placeholder="Seçin" fullWidth />}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            type="date"
            label="Tarih"
            value={assessedOn}
            onChange={(e) => setAssessedOn(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box />

            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
              {(headerChips || []).map((c) => c)}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AssessmentHeader;
